export default "__VITE_ASSET__Dftb6kAW__"